module.exports = __webpack_public_path__ + "img/quickcash_black_and_white.acff626c.png";